import React, { useState } from 'react';
import { Menu, X, ChevronDown } from 'lucide-react';
import { Button } from './ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from './ui/dropdown-menu';
import { languages } from '../mock';

export const Header = ({ language, setLanguage, t, scrollToSection }) => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const navItems = [
    { key: 'home', section: 'hero' },
    { key: 'experience', section: 'experience' },
    { key: 'aestheticProducts', section: 'products' },
    { key: 'supplements', section: 'supplements' },
    { key: 'mesomedics', section: 'mesomedics' },
    { key: 'protocols', section: 'protocols' },
    { key: 'contact', section: 'contact' }
  ];

  const currentLang = languages.find(l => l.code === language);

  return (
    <header className="fixed top-0 left-0 right-0 bg-white/95 backdrop-blur-md shadow-sm z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-32">
          {/* Logo */}
          <div className="flex-shrink-0 cursor-pointer" onClick={() => scrollToSection('hero')}>
            <img 
              src="https://customer-assets.emergentagent.com/job_67b366a2-9c46-4ca8-9e2f-e7e30db89ded/artifacts/74bzcw97_SAFEX%20PHARMA%20LOGO%20IMAGEN%20PNG.png" 
              alt="SAFEX PHARMA" 
              className="h-28 w-auto rounded"
            />
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center space-x-1">
            {navItems.map((item) => (
              <button
                key={item.key}
                onClick={() => scrollToSection(item.section)}
                className="px-4 py-2 text-sm font-medium text-gray-700 hover:text-slate-900 transition-colors duration-200 relative group"
              >
                {t.nav[item.key]}
                <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-slate-800 group-hover:w-full transition-all duration-300"></span>
              </button>
            ))}
          </nav>

          {/* Language Selector */}
          <div className="hidden lg:flex items-center space-x-4">
            <DropdownMenu>
              <DropdownMenuTrigger asChild>
                <Button variant="outline" size="sm" className="border-slate-700 text-slate-700 hover:bg-slate-800 hover:text-white transition-colors duration-200">
                  {currentLang?.name}
                  <ChevronDown className="ml-2 h-4 w-4" />
                </Button>
              </DropdownMenuTrigger>
              <DropdownMenuContent align="end" className="w-48">
                {languages.map((lang) => (
                  <DropdownMenuItem
                    key={lang.code}
                    onClick={() => setLanguage(lang.code)}
                    className={`cursor-pointer ${language === lang.code ? 'bg-slate-100 text-slate-900 font-semibold' : ''}`}
                  >
                    <span className="mr-2">{lang.flag}</span>
                    {lang.name}
                  </DropdownMenuItem>
                ))}
              </DropdownMenuContent>
            </DropdownMenu>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="lg:hidden p-2 rounded-md text-gray-700 hover:bg-gray-100 transition-colors"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          >
            {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {mobileMenuOpen && (
        <div className="lg:hidden bg-white border-t border-gray-200 shadow-lg">
          <nav className="px-4 py-6 space-y-2">
            {navItems.map((item) => (
              <button
                key={item.key}
                onClick={() => {
                  scrollToSection(item.section);
                  setMobileMenuOpen(false);
                }}
                className="block w-full text-left px-4 py-3 text-base font-medium text-gray-700 hover:bg-slate-100 hover:text-slate-900 rounded-lg transition-colors"
              >
                {t.nav[item.key]}
              </button>
            ))}
            <div className="pt-4 border-t border-gray-200">
              <p className="px-4 py-2 text-sm font-medium text-gray-500">Language</p>
              <div className="grid grid-cols-2 gap-2">
                {languages.map((lang) => (
                  <button
                    key={lang.code}
                    onClick={() => {
                      setLanguage(lang.code);
                      setMobileMenuOpen(false);
                    }}
                    className={`px-4 py-2 text-sm rounded-lg transition-colors ${
                      language === lang.code
                        ? 'bg-slate-800 text-white'
                        : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                    }`}
                  >
                    <span className="mr-2">{lang.flag}</span>
                    {lang.name}
                  </button>
                ))}
              </div>
            </div>
          </nav>
        </div>
      )}
    </header>
  );
};